module.exports = __webpack_public_path__ + "static/img/jx-lzxf(xy).d62c901.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jx/jx-lzxf(xy).png
// module id = ZLkZ
// module chunks = 0